export default "__VITE_ASSET__1dd1a00a__"